<template>
    <div>
        <header-navigation :is-reversed="true"></header-navigation>
        <div class="airsense-page">
            <div class="content-shell">
                <div class="page-card">
                    <div class="page-card-inner">
                        <!-- <div class="page-header">
                            <h1>Airsense 12 User Guides</h1>
                        </div> -->

                        <div class="field-group">
                            <label for="country-select">Country</label>
                            <select id="country-select" class="field-select" v-model="selectedCountry"
                                @change="updateLanguages">
                                <option :value="null" disabled>Select Country</option>
                                <option v-for="country in countries" :key="country" :value="country">
                                    {{ country }}
                                </option>
                            </select>
                        </div>

                        <div class="field-group">
                            <label for="language-select">Language</label>
                            <select id="language-select" class="field-select" v-model="selectedLanguage"
                                @change="updateSelectedFile">
                                <option :value="null" disabled>Select Language</option>
                                <option v-for="language in filteredLanguages" :key="language" :value="language">
                                    {{ language }}
                                </option>
                            </select>
                        </div>

                        <div class="button-group">
                            <a v-if="selectedFile" :href="selectedFile.cta_link" target="_blank"
                                rel="noopener noreferrer" class="cta-button">
                                {{ selectedFile.cta_title || 'Go to User Guide PDF' }}
                            </a>
                            <button v-else class="cta-button cta-button--disabled" type="button" disabled>
                                No user guide available
                            </button>
                        </div>
                        <div v-if="apiError" class="error-message">
                            {{ apiError }}
                        </div>

                        <!-- Ensure pageloader component is registered or handled -->
                        <div v-if="loading" class="loader-placeholder">Loading...</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <footer>
            <nav class="company-pages px-3 px-md-0">
                <div class="container">
                    <div class="">
                        <footer-navigation v-bind:category="'quick-links'"></footer-navigation>
                    </div>
                    <hr class="d-none d-md-block" />

                    <div class="row">
                        <div class="col-lg-8 my-5 mt-md-0 my-lg-0">
                            <footer-navigation v-bind:category="'useful-links'"></footer-navigation>
                        </div>

                        <div class="col-lg-4">
                            <social-media></social-media>
                            <div class="copyright-disclaimers d-none d-md-block">
                                <p><span>© ResMed</span> {{ $getTranslation("All rights reserved.",
                                    en - au) }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </footer> -->
        <div class="footer">
            <div v-if="disclaimer" class="disclaimer">
                            {{ disclaimer }}
                        </div>
        </div>
    </div>
</template>

<script>


import headerNavigation from "./components/navigation/header.vue"; 
import footerNavigation from "./components/navigation/footer.vue";
import socialMedia from "./components/navigation/social-media.vue";

export default {
    components: { 
        headerNavigation, 
        footerNavigation, 
        socialMedia 
    },
    name: "AirSense12Page",
    data() {
        return {
            loading: true,
            files: [],
            countries: [],
            selectedCountry: null,
            filteredLanguages: [],
            selectedLanguage: null,
            selectedFile: null,
            disclaimer: "",
            apiError: null,
        };
    },
    async mounted() {
        await this.loadAirsenseData();
    },
    async mounted() {
    // Tell the header to switch to color mode
    if (window.bus) {
        window.bus.$emit("navigation:reversed", true);
    }
    
    await this.loadAirsenseData();
},
// It is good practice to turn it back to white when leaving the page
beforeDestroy() {
    if (window.bus) {
        window.bus.$emit("navigation:reversed", false);
    }
},
    methods: {
        async loadAirsenseData() {
            this.loading = true;
            this.apiError = null;

            const locale = this.$route && this.$route.query ? this.$route.query.locale : "";
            const url = `${process.env.VUE_APP_API_ENDPOINT}/wp-json/resmed/v1/get-page-by-slug?slug=airsense-12-user-guides&locale=${encodeURIComponent(locale)}`;

            try {
                const response = await fetch(url);

                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }

                const payload = await response.json();

                if (!payload || !Array.isArray(payload.fields)) {
                    throw new Error("Unexpected API response format.");
                }

                // Logic to find the specific layout block
                const field = payload.fields.find(
                    (item) => item.acf_fc_layout === "airsense-12-userguides"
                );

                // Fixed: Removed optional chaining (?.) and added traditional checks
                if (!field || !field["airsense-12-userguides"] || !field["airsense-12-userguides"].files) {
                    throw new Error("Could not load Airsense files.");
                }

                const dataContent = field["airsense-12-userguides"];
                this.files = dataContent.files || [];
                this.disclaimer = dataContent.disclaimer || "";

                // Extract unique countries
                this.countries = [...new Set(this.files.map((item) => item.country))];

                if (this.countries.length > 0) {
                    this.selectedCountry = null; // Reset selected country
                    this.updateLanguages();
                }
            } catch (error) {
                console.error("Fetch Error:", error);
                // Fixed: Removed optional chaining
                this.apiError = (error && error.message) ? error.message : "Unable to load data.";
            } finally {
                this.loading = false;
            }
        },
        updateLanguages() {
            if (!this.selectedCountry) {
                this.filteredLanguages = [];
                this.selectedFile = null;
                return;
            }

            this.filteredLanguages = [
                ...new Set(
                    this.files
                        .filter((item) => item.country === this.selectedCountry)
                        .map((item) => item.language)
                ),
            ];
            this.selectedLanguage =  null;
            this.updateSelectedFile();
        },
        updateSelectedFile() {
            this.selectedFile = this.files.find(
                (item) =>
                    item.country === this.selectedCountry &&
                    item.language === this.selectedLanguage
            );
        },
    },
};
</script>

<style scoped>
.airsense-page {
    min-height: calc(100vh - 150px);
    display: flex;
    align-items: center;
    justify-content: center;
    /* background-color: #f6f6f6; */
    padding: 20px 16px;
    font-family: sans-serif;
}

.content-shell {
    width: 100%;
    max-width: 440px;
}

.page-card {
    background-color: #ffffff;
    /* border: 1px solid #0d0a15;
  border-radius: 72px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.06); */
    padding: 22px;
}

.page-card-inner {
    display: flex;
    flex-direction: column;
    gap: 26px;
}

.page-header h1 {
    margin: 0;
    font-size: 28px;
    font-weight: 700;
    line-height: 1.1;
}

.field-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.field-group label {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: capitalize;
    color: #0d0a15;
}

.field-select {
    width: 100%;
    padding: 18px 24px;
    border: 1px solid #0d0a15;
    border-radius: 999px;
    background: #ffffff;
    font-size: 16px;
    color: #0d0a15;
    outline: none;
    appearance: none;
    cursor: pointer;
}

.field-select:focus {
    box-shadow: 0 0 0 4px rgba(13, 10, 21, 0.08);
}

.button-group {
    display: flex;
    justify-content: center;
}

.cta-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 58px;
    padding: 0 28px;
    border-radius: 999px;
    border: none;
    background-color: #0d0a15;
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
    text-decoration: none;
    cursor: pointer;
    text-align: center;
}

.cta-button--disabled {
    background-color: #9e9ea3;
    cursor: not-allowed;
}

.disclaimer {
    font-size: 14px;
    line-height: 1.6;
    color: #5a5a5a;
}

.error-message {
    color: #c72c41;
    font-weight: 600;
}

.loader-placeholder {
    text-align: center;
    padding: 20px;
}
.footer {
    margin-top: 40px;
    padding: 20px;
    text-align: center;
    background-color: #f3f4f6;
}
@media (max-width: 420px) {
    .page-card {
        padding: 24px;
        border-radius: 40px;
    }

    .field-select {
        font-size: 18px;
        padding: 18px 20px;
    }

    .cta-button {
        font-size: 18px;
    }
}
</style>